module.exports = __webpack_public_path__ + "img/1440.0ca41fe1.jpg";